function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "js7r7calga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-search-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-search-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#js7r7calga)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2 20.4a1.191 1.191 0 0 1-.848-.351l-4.607-4.607a8.5 8.5 0 0 1-5.156 1.736 8.59 8.59 0 1 1 8.59-8.591 8.5 8.5 0 0 1-1.736 5.156l4.607 4.607a1.2 1.2 0 0 1-.85 2.05zM8.589 2.4a6.188 6.188 0 1 0 6.188 6.187A6.2 6.2 0 0 0 8.589 2.4z",
    transform: "translate(1.8 1.799)",
    style: {
      fill: "#777"
    },
    "data-name": "icon-search-mono"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.cc4814d95cdf8860bdb830c293181329.svg";
export { ForwardRef as ReactComponent };